import api from '../lib/axios';

export const getTodos = () => api.get('/todos');
export const createTodo = (data) => api.post('/todos', data);
export const updateTodo = (id, data) => api.patch(`/todos/${id}`, data);
export const deleteTodo = (id) => api.delete(`/todos/${id}`);
